<template>
    <div class="map-tag-list-tags" style="position: relative;">
      <div v-if="standardList.length > 1 && standardList[selectedIndex].title" class="map-tag-list-item-title" @mouseenter="tabListShow = true"
           @mouseleave="tabListShow = false">
        <div :class="`${standShape?standShape:'map-tag-cir'}-color`" :title="standardList[selectedIndex].name"
             style="color: #fff;background-color:none;" @click="">
          {{ standardList[selectedIndex].title }}
        </div>
      </div>
      <div class="map-tags-pop" @mouseenter="tabListShow = true" @mouseleave="tabListShow = false" v-if="tabListShow">
        <div @click="selectedIndex = index" v-for="(item, index) in standardList" :key="index" class="map-tags-pop-item"
             :style="`color:${index == selectedIndex ? '#00557f' : '#fff'}`" :title="item.name">{{ item.name }}
        </div>
      </div>
      <div class="map-tag-list-item-title" v-if="standardList.length > 1">
        <template v-if="type == 0">
          <div v-for="(item, index) in standardList[selectedIndex].children"
               style="display:flex;flex-direction:column;justify-content: center;align-items: center">
            <div :class="`${standShape?standShape:'map-tag-cir'}-color`" :title="item.title"
                 :style="'background-color:' + [item.data.show ? item.data.color : '#ccc']" :key="index"
                 @click="$emit('selctTag', index, selectedIndex, item.data.id, true)">
              {{ item.data.title }}
            </div>
          </div>
        </template>
        <template v-if="type == 1">
          <div v-for="(item, index) in standardList[selectedIndex].children"
               style="display:flex;flex-direction:column;justify-content: center;align-items: center">
            <div :class="`${standShape?standShape:'map-tag-cir'}-color`" :title="item.title"
                 :style="'background-color:' + [item.data.show ? item.data.color : '#ccc'] + ';color: #fff;'"
                 :key="index"
                 @click="$emit('selctTag', index, selectedIndex, item.data.id, true)">
              <div :class="`iconfont ${item.data.icon}`"></div>
            </div>
            <!--            <div style="font-size: 10px;text-align: center">-->
            <!--              {{item.data.title}}-->
            <!--            </div>-->
          </div>
        </template>


      </div>
      <div class="map-tag-list-item-title" style="margin-left: 10px;">
        <div :class="`${standShape?standShape:'map-tag-cir'}-color`" v-for="(item, index) in onlineStateList"
             :title="item.title"
             :style="'background-color:' + [item.show ? item.color : '#ccc']" :key="index"
             @click="$emit('selctTag', index, selectedIndex, item.onlineState, false)">
          {{ item.name }}
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: 0,
      tabListShow: false
    }
  },
  props: ['standardList', 'standShape', 'onlineStateList', 'type']
}
</script>

<style lang="scss" scoped>
.map-tag-list-tags {
  min-width: 100px;
  height: 50px;
  position: absolute;
  /* bottom: 16px; */
  bottom: 60px;
  left: 27vw;
  display: flex;
  overflow: initial;

  .map-tags-pop {
    border-radius: 10px;
    padding: 5px;
    position: absolute;
    bottom: 50px;
    font-size: 15px;
    background-color: #111f30;
    display: flex;
    flex-direction: column;

    .map-tags-pop-item {
      cursor: pointer;
      margin: 2px;

      &:hover {
        color: #00557f !important;
      }
    }
  }

  .map-tag-list-item-title {
    background-color: #111f30;
    padding-right: 10px;
    display: flex;
    align-items: center;
    user-select: none;
    border-radius: 10px;

    .map-tag-cir-color {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      font-size: 10px;
      color: #000;
      text-align: center;
      line-height: 30px;
      margin-left: 10px;
      cursor: pointer;
    }

    .map-tag-rec-color {
      width: 30px;
      height: 30px;
      border-radius: 3px;
      font-size: 10px;
      color: #fff;
      text-align: center;
      line-height: 30px;
      margin-left: 10px;
      cursor: pointer;
    }

    .map-tag-none-color {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      font-size: 10px;
      color: #000;
      text-align: center;
      line-height: 30px;
      margin-left: 10px;
      cursor: pointer;
      background-color: #ccc;
    }

    .map-tag-none-rec-color {
      border-radius: 3px;
      width: 30px;
      height: 30px;
      font-size: 10px;
      background-color: #ccc;
      text-align: center;
      color: #000;
      line-height: 30px;
      cursor: pointer;
      margin-left: 10px;
    }
  }


}
</style>
